/* eslint-disable react-hooks/exhaustive-deps */
import {
  Add,
  ArrowLeft,
  DeleteSharp,
  EditSharp,
  RemoveRedEye,
  UploadFile
} from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  IconButton,
  Modal,
  Radio,
  RadioGroup,
  Stack,
  Switch,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import React, { useState, useEffect } from "react";
import Select from "react-select";
import DataTable from "react-data-table-component";
import Page from "src/components/Page";
import styled from "styled-components";
import moment from "moment";
import { notification } from "src/utils/messages";
import {
  insertPrimeNotification,
  updatePrimeNotification,
  deletenotification,
  getReadPrimeNotificationData,
  getNotificationChildren
} from "src/api/commonapi";
import { Routes } from "../constant/api_url";
import Deletemodal from "./DeleteModal";
import Label from "../components/Label";
import { CSVLink } from "react-csv";
import { CKEditor } from "ckeditor4-react";
import {
  fetchPrimeNotificationList,
  PollSelect,
  fetchallcitylist,
  fetchallstatelist
} from "src/utils/common";
import CustomLoader from "src/components/CustomLoader";
import NotificationFilters from "./Notification/NotificationFilters";
import NotificationTable from "./Notification/NotificationTable";
import DeleteConfirmDialog from "./Notification/DeleteConfirmDialog";
import ScheduleEntryList from "./Notification/ScheduleEntryList";

function Notification() {
  const readNotificationModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 900,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };
  let loginUser = JSON.parse(localStorage.getItem("userData"));
  const [notificationList, setNotificationList] = useState([]);
  const [newNotificationList, setNewNotificationList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  // 0- All, 1- insert, 2-update
  const [page, setPage] = useState(0);
  // Edit mode: only content fields + schedule end date are editable
  const isEditMode = page === 2;
  // Field/schedule lock — applies only once the batch has actually been sent
  const [sentLocked, setSentLocked] = useState(false);
  const lockFields = isEditMode && sentLocked;
  const [setfile, setFile] = useState({});
  const [fileimage, setfileimage] = useState();
  const imageTypes = ["png", "jpg", "jpeg", "gif", "webp"];
  const videoTypes = ["mp3", "wav", "ogg"];

  const handlePageViewChange = (newPageValue) => {
    setPage(newPageValue);
  };
  const [dvisible, setDvisible] = useState({ mval: false, id: 0 });
  const [isFormSubmit, setIsFormSubmit] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [scheduleEntries, setScheduleEntries] = useState([
    {
      s_date: moment().format("DD-MM-YYYY"),
      e_date: "",
      notification_send_type: "0",
      n_date_time: "",
      show_on_home: 0,
      _uid: `entry_${Date.now()}`
    }
  ]);
  const [removedSubIds, setRemovedSubIds] = useState([]);
  const [forTypeOptions, setForTypeOptions] = useState([]);
  const [hasMoreForType, setHasMoreForType] = useState(true);
  const [isLoadingForTypeOptions, setIsLoadingForTypeOptions] = useState(false);
  const [forTypeSearchInput, setForTypeSearchInput] = useState("");
  const [forTypeDebouncedSearch, setForTypeDebouncedSearch] = useState("");
  const [selectedForTypeOpts, setSelectedForTypeOpts] = useState([]);
  // Full (unpaginated) state/city lists, used once to resolve the labels of already
  // saved selections that aren't present in the current server-side page.
  const [forTypeFullLookup, setForTypeFullLookup] = useState(null);
  const loadingForTypeRef = React.useRef(false);
  const forTypePageRef = React.useRef(1);
  useEffect(() => {
    const id = setTimeout(() => setForTypeDebouncedSearch(forTypeSearchInput), 350);
    return () => clearTimeout(id);
  }, [forTypeSearchInput]);
  const [openPreview, setOpenPreview] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    perPage: 10,
    totalRecords: 0
  });
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deletedCount, setDeletedCount] = useState(null);

  const NotificationStatus = [
    { label: "All", value: 0 },
    { label: "Open ", value: 1 },
    { label: "Close", value: 2 }
  ];
  const NotificationType = [
    { label: "All", value: -1 },
    { label: "Photo ", value: 0 },
    { label: "Audio", value: 1 },
    { label: "Video", value: 2 },
    { label: "Question and Answer", value: 3 }
  ];
  const NotificationTo = [
    { label: "All", value: 0 },
    { label: "Orange Tick ", value: 7 },
    { label: "Not Orange Tick", value: 8 }
  ];
  const [filtereddata, setFilteredData] = useState({
    notificationFor: -1,
    notificationStatus: 0,
    notificationType: -1,
    n_to: 0,
    search: "",
    startDate: "",
    endDate: ""
  });

  const getYoutubeVideoId = (url) => {
    if (!url) return null;
    const regExp = /^.*(?:youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]{11}).*/;
    const match = url.match(regExp);
    return match ? `https://www.youtube.com/embed/${match[1]}` : null;
  };

  const [formData, setFormData] = useState({
    n_title: "",
    n_description: "<p></p>",
    n_link: "",
    n_button_title: "",
    n_image: "",
    n_video: "",
    n_question: "",
    n_answer: "<p></p>",
    // 0-Photo: "", 1-Audio: "", 2-Video: "", 3-Question and Answer
    n_type: "0",
    n_to: "0",
    s_date: moment().format("DD-MM-YYYY"),
    e_date: "",
    n_send_to: "0", // 0-all, 1-LT, 2-members
    n_for_type: "4", // 4 - LVB Prime, 1- State, 2- City
    n_for_id: "",
    n_status: "1", // status: 0-Inactive, 1-Active
    show_on_home: 0
  });

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1
  });

  const getAcceptType = (type) => {
    switch (type) {
      case "0":
        return "image/*,.jpg,.jpeg,.png,.gif";
      case "1":
        return "audio/*,.mp3,.wav,.ogg";
      case 0:
        return "image/*,.jpg,.jpeg,.png,.gif";
      case 1:
        return "audio/*,.mp3,.wav,.ogg";
      default:
        return "";
    }
  };

  const resetFormData = () => {
    setFormData({
      n_title: "",
      n_description: "<p></p>",
      n_link: "",
      n_button_title: "",
      n_image: "",
      n_audio: "",
      n_video: "",
      n_question: "",
      n_answer: "<p></p>",
      n_type: "0",
      n_to: "0",
      s_date: moment().format("DD-MM-YYYY"),
      e_date: "",
      n_send_to: "0",
      n_for_type: "4",
      n_for_id: "",
      n_status: "1",
      show_on_home: 0
    });
    setScheduleEntries([
      {
        s_date: moment().format("DD-MM-YYYY"),
        e_date: "",
        notification_send_type: "0",
        n_date_time: "",
        show_on_home: 0,
        _uid: `entry_${Date.now()}`
      }
    ]);
    setRemovedSubIds([]);
    setSentLocked(false);
  };

  // --- Privilege-parity submit (no duplicate validation, relies on validationHandler) ---
  const handleFormSubmit = async () => {
    try {
      setIsFormSubmit(true);
      let fData = new FormData();
      // Shared fields (as in Privilege handleFormSubmit)
      fData.append("n_type", formData.n_type);
      fData.append("n_send_to", formData.n_send_to);
      fData.append("n_for_type", formData.n_for_type);
      fData.append("n_to", formData.n_to);
      fData.append("n_for_id", formData.n_for_id);
      fData.append("n_status", formData.n_status);
      fData.append("n_link", formData.n_link || "");
      fData.append("n_button_title", formData.n_button_title || "");
      // Type-specific fields
      if (formData.n_type == 0 || formData.n_type == 1) {
        fData.append("n_title", formData.n_title);
        fData.append("n_description", formData.n_description);
        if (setfile?.file) fData.append("n_image", setfile.file);
      } else if (formData.n_type == 2) {
        fData.append("n_title", formData.n_title);
        fData.append("n_description", formData.n_description);
        fData.append("n_video", formData.n_video);
      } else if (formData.n_type == 3) {
        fData.append("n_question", formData.n_question);
        fData.append("n_answer", formData.n_answer);
      }
      // Schedule entries JSON – prime uses separate scheduleEntries state (vs privilege formData.schedule_entries)
      const isEditPayload = formData.n_id != undefined;
      const schedulePayload = scheduleEntries.map((e) => {
        const obj = {
          s_date: moment(e.s_date, ['DD-MM-YYYY hh:mm A', 'DD-MM-YYYY'], true).format('DD-MM-YYYY'),
          e_date: e.e_date,
          notification_send_type: String(e.notification_send_type),
          n_date_time: e.n_date_time || "",
          show_on_home: e.show_on_home || 0
        };
        if (isEditPayload && e.n_id) obj.n_id = e.n_id;
        return obj;
      });
      fData.append("schedule_entries", JSON.stringify(schedulePayload));
      if (formData.n_id != undefined) {
        fData.append("n_id", formData.n_id);
        fData.append("linked_edit", "1");
        if (removedSubIds.length > 0) {
          fData.append("remove_sub_ids", JSON.stringify(removedSubIds));
        }
        const resp = await updatePrimeNotification(fData);
        notification({ type: resp.status == 0 ? "error" : "success", message: resp.message, position: "top" })();
        if (resp.status == 1) {
          // Leave the form BEFORE resetting: resetting rewrites the CKEditor
          // initData at the same moment the editor unmounts, which throws
          // "Cannot read properties of null (reading 'unselectable')".
          setPage(0);
          getNotificationList();
          setfileimage();
          setFile({});
        }
      } else {
        const resp = await insertPrimeNotification(fData);
        notification({ type: resp.status == 0 ? "error" : "success", message: resp.message, position: "top" })();
        if (resp.status == 1) {
          setPage(0);
          getNotificationList();
          setfileimage();
          setFile({});
        }
      }
    } catch (e) {
      console.log("Error", e);
    } finally {
      setIsFormSubmit(false);
      setOpenPreview(false);
    }
  };

  const notificationdelete = async (n_id) => {
    const resp = await deletenotification(n_id);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message: resp.message,
      position: "top"
    });
    notify();

    if (resp.status == 1) {
      setDvisible({ mval: false, id: 0 });
      getNotificationList(pagination.currentPage, pagination.perPage);
    }
  };

  const getNotificationList = async (page = 1, perPage = 10, filters = filtereddata) => {
    setIsLoading(true);
    try {
      const result = await fetchPrimeNotificationList(loginUser.u_type, {
        page,
        limit: perPage,
        n_for_type: filters.notificationFor,
        n_type: filters.notificationType,
        notification_status: filters.notificationStatus,
        search: filters.search
      });
      if (result.data) {
        setNotificationList(result.data);
        setNewNotificationList(result.data);
        setPagination({
          currentPage: result.pagination?.current_page || 1,
          perPage: result.pagination?.per_page || 10,
          totalRecords: result.pagination?.total_records || 0
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    getNotificationList(newPage, pagination.perPage);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    getNotificationList(page, newPerPage);
  };

  useEffect(() => {
    getNotificationList(1, pagination.perPage, filtereddata);
  }, [filtereddata]);

  // Track removed sub IDs when schedule entries change (for edit mode)
  const prevScheduleEntriesRef = React.useRef(scheduleEntries);
  useEffect(() => {
    if (formData.n_id) {
      const prevEntries = prevScheduleEntriesRef.current;
      const currentIds = scheduleEntries.map((e) => e.n_id).filter(Boolean);
      const prevIds = prevEntries.map((e) => e.n_id).filter(Boolean);
      const removedIds = prevIds.filter((id) => !currentIds.includes(id));
      if (removedIds.length > 0) {
        setRemovedSubIds((prev) => [...prev, ...removedIds]);
      }
    }
    prevScheduleEntriesRef.current = scheduleEntries;
  }, [scheduleEntries]);

  // Fetch State/City options when n_for_type changes (backend supports search + pagination)
  const fetchForTypeOptions = React.useCallback(
    async (page = 1, append = false, search = "") => {
      const type = formData.n_for_type;
      if (!type || type === "4" || type === 4) {
        setForTypeOptions([]);
        setHasMoreForType(false);
        return;
      }
      if (loadingForTypeRef.current) return;
      loadingForTypeRef.current = true;
      setIsLoadingForTypeOptions(true);
      try {
        const resp = await PollSelect(type, page, 10, search);
        if (resp && resp.status === 1 && resp.data) {
          const newOpts = resp.data.map((e) => ({ value: e.value, label: e.name }));
          setForTypeOptions((prev) => (append ? [...prev, ...newOpts] : newOpts));
          setHasMoreForType(newOpts.length >= 10);
          forTypePageRef.current = page + 1;
        } else {
          if (!append) setForTypeOptions([]);
          setHasMoreForType(false);
        }
      } catch {
        if (!append) setForTypeOptions([]);
        setHasMoreForType(false);
      } finally {
        setIsLoadingForTypeOptions(false);
        loadingForTypeRef.current = false;
      }
    },
    [formData.n_for_type]
  );

  useEffect(() => {
    setForTypeOptions([]);
    setHasMoreForType(true);
    forTypePageRef.current = 1;
    fetchForTypeOptions(1, false, forTypeDebouncedSearch);
  }, [formData.n_for_type, forTypeDebouncedSearch]);

  const handleForTypeMenuScroll = () => {
    if (hasMoreForType && !isLoadingForTypeOptions) {
      fetchForTypeOptions(forTypePageRef.current, true, forTypeDebouncedSearch);
    }
  };

  const handleForTypeInputChange = (newValue, actionMeta) => {
    if (actionMeta.action === "input-change") {
      setForTypeSearchInput(newValue);
    }
    return newValue;
  };

  // Selected options are held as objects, not derived from `forTypeOptions` — with
  // server-side search/pagination a saved state/city may not be in the fetched page,
  // which used to render no chip at all.
  const parseSelectedForTypeIds = React.useCallback(
    () =>
      (formData.n_for_id || "")
        .toString()
        .replace(/^\[|\]$/g, "")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean),
    [formData.n_for_id]
  );

  useEffect(() => {
    const ids = parseSelectedForTypeIds();
    if (!ids.length) {
      setSelectedForTypeOpts([]);
      return;
    }
    setSelectedForTypeOpts((prev) =>
      ids.map((id) => {
        const found =
          forTypeOptions.find((o) => String(o.value) === String(id)) ||
          (forTypeFullLookup ? forTypeFullLookup[String(id)] : null);
        if (found) return found;
        const kept = prev.find((o) => String(o.value) === String(id));
        return kept || { value: id, label: `#${id}` };
      })
    );
  }, [forTypeOptions, forTypeFullLookup, parseSelectedForTypeIds]);

  // On edit, resolve saved ids against the full list once. The paged endpoint is not
  // usable for this: ids are not returned in ascending order, so an older id (e.g. 1)
  // may never appear on any early page.
  useEffect(() => {
    const isState = String(formData.n_for_type) === "1";
    const isCity = String(formData.n_for_type) === "2";
    if (!isState && !isCity) {
      setForTypeFullLookup(null);
      return;
    }
    if (!parseSelectedForTypeIds().length) return;
    if (forTypeFullLookup) return;
    let cancelled = false;
    (async () => {
      try {
        const raw = isState ? await fetchallstatelist() : await fetchallcitylist();
        if (cancelled || !raw) return;
        const list = Array.isArray(raw) ? raw : raw?.data;
        if (!Array.isArray(list)) return;
        const map = {};
        list.forEach((r) => {
          const id = isState ? r?.state_id : r?.city_id;
          const name = isState ? r?.state_name : r?.city_name;
          if (id != undefined && name) map[String(id)] = { value: id, label: name };
        });
        if (!cancelled) setForTypeFullLookup(map);
      } catch {
        // leave unresolved ids showing #<id>
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [formData.n_for_type, forTypeFullLookup, parseSelectedForTypeIds]);

  const [readNotificationDataModal, setReadNotificationDataModal] = useState(false);
  const [readNotificationList, setReadNotificationList] = useState([]);

  // Open modal with notification ID
  const openModalWithNotification = async (n_id) => {
    setReadNotificationDataModal(true); // Open modal

    try {
      setIsLoading2(true);
      const resp = await getReadPrimeNotificationData(n_id);
      setIsLoading2(false);
      if (resp.status === 1) {
        setReadNotificationList(resp.data);
      } else {
        setReadNotificationList([]);
      }
    } catch (error) {
      console.error("Error fetching notification data:", error);
    }
  };

  // Close modal and reset state
  const closeModal = () => {
    setReadNotificationDataModal(false);
    setReadNotificationList([]);
  };

  const readNotificationDetailColumns = [
    {
      name: "Member Name",
      selector: (row) => row?.m_name,
      sortable: true
    },
    {
      name: "Notification Read Date",
      selector: (row) => row?.r_date,
      sortable: true
    },
    {
      name: "Status",
      selector: (row) => (
        <>
          <Label
            variant="ghost"
            color="success"
            style={{
              marginBottom: "10px",
              display: "flex",
              fontSize: "16px"
            }}
          >
            Read
          </Label>
        </>
      ),
      sortable: true
    }
  ];

  const export_readNotificationDetailColumns = [
    { label: "Member Name", key: "m_name" },
    { label: "Notification Read Date", key: "r_date" }
  ];

  const expo_columns = [
    { label: "No", key: "n_id" },
    { label: "Type", key: "Notification_type" },
    { label: "Notification To", key: "n_to" },
    { label: "Title", key: "n_title" },
    { label: "Description", key: "n_description" },
    { label: "URL", key: "n_link" },
    { label: "Button Title", key: "n_button_title" },
    { label: "Question", key: "n_question" },
    { label: "Answer", key: "n_answer" },
    { label: "Start Date", key: "s_date" },
    { label: "End Date", key: "e_date" },
    { label: "Notification Send Date & Time", key: "n_date_time" },
    { label: "Created Date", key: "timestamp" }
  ];

  const columns = [
    {
      name: "No",
      wrap: true,
      selector: (row, index) => index + 1,
      sortable: true,
      width: "70px"
    },
    {
      name: "Type",
      wrap: true,
      width: "90px",
      selector: (row) => row.Notification_type
    },
    {
      name: "Image/Audio/Video",
      wrap: true,
      width: "150px",
      cell: (row) => {
        if (row.n_type === 1) {
          return (
            <audio controls src={`${Routes.API_HOSTNAME}images/notification/${row.n_image}`} />
          );
        } else if (row.n_type === 0) {
          return (
            <img
              src={`${Routes.API_HOSTNAME}images/notification/${row.n_image}`}
              alt="img"
              width="100"
            />
          );
        } else if (row.n_type === 2) {
          return row.n_video;
        } else {
          return "-";
        }
      }
    },
    {
      name: "Notification To",
      wrap: true,
      width: "150px",
      selector: (row) => NotificationTo?.find((opt) => opt?.value == row?.n_to)?.label || "-",
      sortable: true
    },
    {
      name: "Title",
      wrap: false,
      width: "150px",
      cell: (row) => {
        const content = row.n_title ?? "-";
        return (
          <div title={content}>{content.length > 30 ? content.slice(0, 30) + "..." : content}</div>
        );
      },
      sortable: true
    },
    {
      name: "URL",
      wrap: true,
      width: "120px",
      selector: (row) => (row.n_link != null && row.n_link != "" ? row.n_link : "-"),
      sortable: true
    },
    {
      name: "Button Title",
      wrap: true,
      width: "120px",
      selector: (row) =>
        row.n_button_title != null && row.n_button_title != "" ? row.n_button_title : "-",
      sortable: true
    },
    {
      name: "Question",
      wrap: false,
      width: "150px",
      cell: (row) => {
        const content = row.n_question ?? "-";
        return (
          <div title={content}>{content.length > 30 ? content.slice(0, 30) + "..." : content}</div>
        );
      },
      sortable: true
    },
    {
      name: "Start Date",
      wrap: true,
      width: "120px",
      selector: (row) => row.s_date,
      sortable: true
    },
    {
      name: "End Date",
      selector: (row) => row.e_date,
      wrap: true,
      width: "120px",
      sortable: true
    },
    {
      name: "Notification Send Date & Time",
      selector: (row) => row.n_date_time,
      wrap: true,
      width: "120px",
      sortable: true
    },
    {
      name: "Created Date",
      selector: (row) => formatDate(row.timestamp),
      wrap: true,
      width: "120px",
      sortable: true
    },
    {
      name: "Action",
      wrap: true,
      width: "150px",
      cell: (row) => (
        <>
          <button
            onClick={() => handleDeleteClick(row)}
            style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
          >
            <Tooltip title="Delete">
              <IconButton>
                <DeleteSharp color="error" />
              </IconButton>
            </Tooltip>
          </button>
          <button
            onClick={() => handleEdit(row)}
            style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
          >
            <Tooltip title="Edit">
              <IconButton>
                <EditSharp color="warning" />
              </IconButton>
            </Tooltip>
          </button>
          <button
            onClick={() => openModalWithNotification(row.n_id)}
            style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
          >
            <Tooltip title="See Assign Member List">
              <IconButton>
                <RemoveRedEye color="success" />
              </IconButton>
            </Tooltip>
          </button>
        </>
      )
    }
  ];
  const ExpandableRow = ({ data }) => {
    return (
      <>
        <div style={{ padding: "5px 15px", backgroundColor: "#f3f3f39c" }}>
          <p>
            <b>Description:</b>
          </p>
          <div dangerouslySetInnerHTML={{ __html: data?.n_description ?? "-" }} />
        </div>
        <div style={{ padding: "5px 15px", backgroundColor: "#f3f3f39c" }}>
          <p>
            <b>Answer:</b>
          </p>
          <div dangerouslySetInnerHTML={{ __html: data?.n_answer ?? "-" }} />
        </div>
      </>
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";

    // Ensure correct date format
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";

    // Extract day, month, year
    let day = String(date.getDate()).padStart(2, "0");
    let month = String(date.getMonth() + 1).padStart(2, "0");
    let year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  function htmlToPlainText(html) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  }

  const formattedCSVData = newNotificationList?.map((row, index) => ({
    n_id: index + 1,
    notification_type: row.notification_type,
    n_to: NotificationTo?.find((opt) => opt?.value == row?.n_to)?.label || "-",
    n_title: row.n_title,
    n_description: htmlToPlainText(row.n_description || ""),
    n_link: row.n_link,
    n_button_title: row.n_button_title,
    n_question: row.n_question,
    n_answer: htmlToPlainText(row.n_answer || ""),
    s_date: row.s_date,
    e_date: row.e_date,
    n_date_time: row.n_date_time,
    timestamp: formatDate(row.timestamp)
  }));

  const handleDeleteClick = (row) => {
    if (row.sub_count > 0) {
      setDeleteTarget(row);
      setDeletedCount(null);
      setDeleteDialogOpen(true);
    } else {
      setDvisible({ mval: true, id: row.n_id });
    }
  };

  const handleConfirmDelete = async () => {
    if (!deleteTarget) return;
    const resp = await deletenotification(deleteTarget.n_id);
    let notify = notification({
      type: resp.status == 0 ? "error" : "success",
      message:
        resp.status === 1 && resp.deleted_count
          ? `${resp.deleted_count} notification${resp.deleted_count !== 1 ? "s" : ""} deleted successfully`
          : resp.message,
      position: "top"
    });
    notify();
    if (resp.status === 1) {
      setDeleteDialogOpen(false);
      setDeleteTarget(null);
      setDeletedCount(null);
      getNotificationList(pagination.currentPage, pagination.perPage);
    }
  };

  const handleEdit = async (row) => {
    setIsLoading(true);
    try {
      const resp = await getNotificationChildren(row.n_id);
      if (resp.status === 1) {
        const isSubClick = String(row.is_main) === "0" && row.n_id != undefined;
        let rows;
        let allBatchRows = Array.isArray(resp.data) ? resp.data : [];
        if (isSubClick) {
          // Editing a SUB entry -> scope the form to just that entry (Privilege parity).
          // The children endpoint is keyed on the PARENT id, so querying the sub's own
          // n_id returns [] — fetch the parent's children to learn what the siblings
          // are set to (needed for the single "Send Immediately" slot).
          const parentId = row.n_parent_id ?? row.parent_n_id ?? row.n_parentId;
          if (parentId != undefined && parentId !== null && String(parentId) !== String(row.n_id)) {
            try {
              const parentResp = await getNotificationChildren(parentId);
              if (parentResp.status === 1 && Array.isArray(parentResp.data)) {
                allBatchRows = [...parentResp.data, row];
              }
            } catch {
              // keep allBatchRows as-is; immediate slot simply stays unguarded
            }
          }
          rows = [row];
        } else {
          rows = Array.isArray(resp.data) ? [...resp.data] : [];
          // Single notification has no children (data: []) — use clicked row as main
          if (rows.length === 0) {
            rows = [{ ...row, is_main: 1 }];
          } else if (!rows.some((e) => String(e.is_main) === "1")) {
            // Fallback: children endpoint returned subs only → prepend clicked row as main
            rows = [{ ...row, is_main: 1 }, ...rows];
          }
          // Main first so index-based badges/payload order stay correct
          rows.sort(
            (a, b) => (String(b.is_main) === "1" ? 1 : 0) - (String(a.is_main) === "1" ? 1 : 0)
          );
        }
        const mainEntry = isSubClick ? row : rows.find((e) => String(e.is_main) === "1") || rows[0];
        // n_id of whichever entry in the whole batch currently claims "Send Immediately"
        // (falls back to the clicked row when the children endpoint returned nothing)
        const immediateHolder = allBatchRows.find(
          (e) => String(e.notification_send_type) === "1" && String(e.n_id) !== String(row.n_id)
        );
        // The children endpoint returns subs only, so the MAIN entry's send type is not in
        // allBatchRows — fall back to the value carried over from the list row.
        const parentIsImmediate = String(row.parent_send_type) === "1";
        const immediateHolderId = immediateHolder
          ? immediateHolder.n_id
          : parentIsImmediate
            ? row.n_parent_id ?? row.parent_n_id ?? row.n_parentId ?? "__parent_immediate__"
            : String(row.notification_send_type) === "1"
              ? row.n_id
              : null;
        const entries = rows.map((e) => ({
          s_date: e.s_date,
          e_date: e.e_date,
          notification_send_type: String(e.notification_send_type ?? "0"),
          n_date_time: e.n_date_time || "",
          show_on_home: e.show_on_home || 0,
          n_id: e.n_id,
          n_parent_id: e.n_parent_id,
          is_main: String(e.is_main) === "1" ? 1 : 0,
          notification_send_status: e.notification_send_status,
          // Batch-wide immediate slot holder, so a sub-only form still sees it
          batch_immediate_holder_id: immediateHolderId,
          _uid: `entry_${e.n_id || Date.now()}_${Math.random().toString(36).slice(2, 6)}`
        }));
        // Record-level lock: only when EVERY entry of this batch has already been sent.
        // Partially-sent batches stay fully editable at the form level so the
        // remaining unsent entries can still have all their dates adjusted.
        const allSent =
          rows.length > 0 && rows.every((e) => String(e.notification_send_status) === "1");
        setSentLocked(allSent);
        setFormData({
          ...mainEntry,
          n_id: mainEntry.n_id
        });
        setScheduleEntries(entries);
        setPage(2);
      }
    } finally {
      setIsLoading(false);
    }
  };

  // --- Privilege-parity validation (CKEditor <p>&nbsp; considered empty, file ext check, youtube check) ---
  const isRichTextEmpty = (html) => {
    if (html === null || html === undefined) return true;
    const text = String(html)
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/gi, " ")
      .replace(/ /g, " ")
      .trim();
    return text === "";
  };

  const validateScheduleEntries = (entries) => {
    if (!entries || entries.length === 0) {
      notification({ type: "error", message: "At least one schedule entry is required.", position: "top" })();
      return false;
    }
    const immediateCount = entries.filter(
      (e) => e.notification_send_type === "1" || e.notification_send_type === 1
    ).length;
    if (immediateCount > 1) {
      notification({ type: "error", message: "Only one entry can be 'Send Immediately' per batch.", position: "top" })();
      return false;
    }
    for (let i = 0; i < entries.length; i++) {
      const entry = entries[i];
      if (!entry.s_date) {
        notification({ type: "error", message: `Entry ${i + 1}: Start Date is required.`, position: "top" })();
        return false;
      }
      if (!entry.e_date) {
        notification({ type: "error", message: `Entry ${i + 1}: End Date is required.`, position: "top" })();
        return false;
      }
      if (moment(entry.e_date, "DD-MM-YYYY").isBefore(moment(entry.s_date, "DD-MM-YYYY"))) {
        notification({ type: "error", message: `Entry ${i + 1}: End Date cannot be before Start Date.`, position: "top" })();
        return false;
      }
      if (entry.notification_send_type === "0" && entry.n_date_time) {
        const dt = moment(entry.n_date_time, "DD-MM-YYYY hh:mm A");
        const start = moment(entry.s_date, "DD-MM-YYYY").startOf("day");
        const end = moment(entry.e_date, "DD-MM-YYYY").endOf("day");
        if (!dt.isSameOrAfter(start) || !dt.isSameOrBefore(end)) {
          notification({
            type: "error",
            message: `Entry ${i + 1}: Send Date & Time must be between Start Date and End Date.`,
            position: "top"
          })();
          return false;
        }
      }
      if ((entry.notification_send_type === "0" || entry.notification_send_type === 0) && !entry.n_date_time) {
        notification({
          type: "error",
          message: `Entry ${i + 1}: Notification Send Date & Time is required for scheduled entries.`,
          position: "top"
        })();
        return false;
      }
    }
    return true;
  };

  const validationHandler = () => {
    // Validate schedule entries first (as in Privilege)
    if (!validateScheduleEntries(scheduleEntries)) return false;

    // Validate type-specific fields (Privilege messages)
    if (formData.n_type == 0 || formData.n_type == 1) {
      let fileExtension = "";
      if (formData.n_image) fileExtension = formData.n_image.split(".").pop().toLowerCase();
      let isValidFile = false;
      if (formData.n_type == 0) isValidFile = imageTypes.includes(fileExtension);
      else if (formData.n_type == 1) isValidFile = videoTypes.includes(fileExtension);
      const missingFile = !isValidFile && (setfile == "" || Object.keys(setfile).length === 0);
      const missingTitle = (formData.n_title || "").trim() == "";
      const missingDesc = isRichTextEmpty(formData.n_description);
      if (missingFile || missingTitle || missingDesc) {
        const msg = missingTitle
          ? "Please enter Title"
          : missingDesc
            ? "Please enter Description"
            : "Please upload file";
        notification({ type: "error", message: msg, position: "top" })();
        return false;
      }
    } else if (formData.n_type == 2) {
      if ((formData.n_title || "").trim() == "") {
        notification({ type: "error", message: "Please enter Title", position: "top" })();
        return false;
      }
      if (isRichTextEmpty(formData.n_description)) {
        notification({ type: "error", message: "Please enter Description", position: "top" })();
        return false;
      }
      if (formData.n_video == "") {
        notification({ type: "error", message: "Please enter Video URL", position: "top" })();
        return false;
      }
      if (getYoutubeVideoId(formData?.n_video) == null) {
        notification({ type: "error", message: "Please enter a valid YouTube URL", position: "top" })();
        return false;
      }
    } else if (formData.n_type == 3) {
      if ((formData.n_question || "").trim() == "") {
        notification({ type: "error", message: "Please enter Question", position: "top" })();
        return false;
      }
      if (isRichTextEmpty(formData.n_answer)) {
        notification({ type: "error", message: "Please enter Answer", position: "top" })();
        return false;
      }
    }
    // Validate targeting (prime: LVB/State/City only, no Chapter)
    if (
      formData.n_send_to === null ||
      formData.n_send_to === undefined ||
      formData.n_for_type === null ||
      formData.n_for_type === undefined ||
      formData.n_to === null ||
      formData.n_to === undefined ||
      (formData.n_for_type != 4 &&
        formData.n_for_type != "4" &&
        (formData.n_for_id === "0" || formData.n_for_id === "" || formData.n_for_id === null || formData.n_for_id === undefined))
    ) {
      notification({ type: "error", message: "Please enter all required fields to submit", position: "top" })();
      return false;
    }
    return true;
  };

  return (
    <>
      <Deletemodal visible={dvisible} setVisible={setDvisible} deletefunc={notificationdelete} />
      <DeleteConfirmDialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        onConfirm={handleConfirmDelete}
        subCount={deleteTarget?.sub_count || 0}
        deletedCount={deletedCount}
      />

      <Page title="Notification | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
            <Typography variant="h4" gutterBottom className="mb-0">
              Notification
            </Typography>
            {page === 0 ? (
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  resetFormData();
                  handlePageViewChange(1);
                  setIsFormSubmit(false);
                }}
              >
                <Add sx={{ fontSize: "20px", marginRight: "5px" }} />
                Add Notification
              </Button>
            ) : (
              <Button
                variant="outlined"
                color="primary"
                disabled={isFormSubmit}
                onClick={() => {
                  resetFormData();
                  setPage(0);
                  setfileimage();
                }}
              >
                <ArrowLeft sx={{ fontSize: "20px", marginRight: "5px" }} />
                Back
              </Button>
            )}
          </Stack>

          {page != 0 ? (
            <>
              <Card style={{ padding: "20px" }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography
                      variant="h6"
                      gutterBottom
                      className=""
                      style={{ textAlign: "center" }}
                    >
                      {page === 1 ? "Add New Notification" : "Edit Notification"}
                    </Typography>
                    <hr style={{ marginBottom: "0", marginTop: "0" }} />
                  </Grid>
                  <Grid item xs={12}>
                    <FormLabel> Select Type</FormLabel>
                    <Stack>
                      <RadioGroup
                        row
                        defaultValue={0}
                        value={formData?.n_type}
                        onChange={(e) => {
                          if (page == 1) {
                            setFormData({
                              ...formData,
                              n_type: e.target.value,
                              n_to: "0",
                              n_title: "",
                              n_description: "",
                              n_link: "",
                              n_button_title: "",
                              n_image: "",
                              n_audio: "",
                              n_video: "",
                              n_question: "",
                              n_answer: "",
                              s_date: moment().format("DD-MM-YYYY"),
                              e_date: "",
                              notification_send_type: "0",
                              n_date_time: "",
                              n_send_to: "0",
                              n_for_type: "4",
                              n_for_id: "",
                              n_status: "1",
                              show_on_home: 0
                            });
                            setFile({});
                            setfileimage();
                          } else {
                            setFormData({
                              ...formData,
                              n_type: e.target.value
                            });
                          }
                        }}
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="n_type"
                      >
                        <FormControlLabel
                          value={0}
                          control={<Radio disabled={lockFields} />}
                          label="Photo"
                          disabled={lockFields}
                        />
                        <FormControlLabel
                          value={1}
                          control={<Radio disabled={lockFields} />}
                          label="Audio"
                          disabled={lockFields}
                        />
                        <FormControlLabel
                          value={2}
                          control={<Radio disabled={lockFields} />}
                          label="Video"
                          disabled={lockFields}
                        />
                        <FormControlLabel
                          value={3}
                          control={<Radio disabled={lockFields} />}
                          label="Question and Answer"
                          disabled={lockFields}
                        />
                      </RadioGroup>
                    </Stack>
                  </Grid>
                  <Grid item xs={12}>
                    <FormLabel>Notification To</FormLabel>
                    <Stack>
                      <RadioGroup
                        row
                        defaultValue={0}
                        value={formData?.n_to}
                        onChange={(e) => {
                          if (page == 1) {
                            setFormData({
                              ...formData,
                              n_to: e.target.value
                            });
                            setFile({});
                            setfileimage();
                          } else {
                            setFormData({
                              ...formData,
                              n_to: e.target.value
                            });
                          }
                        }}
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="n_to"
                      >
                        <FormControlLabel
                          value={0}
                          control={<Radio disabled={lockFields} />}
                          label="All"
                          disabled={lockFields}
                        />
                        <FormControlLabel
                          value={7}
                          control={<Radio disabled={lockFields} />}
                          label="Orange Tick"
                          disabled={lockFields}
                        />
                        <FormControlLabel
                          value={8}
                          control={<Radio disabled={lockFields} />}
                          label="Not Orange Tick"
                          disabled={lockFields}
                        />
                      </RadioGroup>
                    </Stack>
                  </Grid>
                  <Grid item xs={12}>
                    <Stack>
                      <FormLabel>Notification For</FormLabel>
                      <RadioGroup
                        row
                        value={formData?.n_for_type}
                        onChange={(e) => {
                          setForTypeSearchInput("");
                          setForTypeDebouncedSearch("");
                          setSelectedForTypeOpts([]);
                          setForTypeFullLookup(null);
                          setFormData({
                            ...formData,
                            n_for_type: e.target.value,
                            n_for_id: ""
                          });
                          setForTypeOptions([]);
                        }}
                        name="n_for_type"
                      >
                        <FormControlLabel
                          value="4"
                          control={<Radio disabled={lockFields} />}
                          label="LVB Prime"
                          disabled={lockFields}
                        />
                        <FormControlLabel
                          value="1"
                          control={<Radio disabled={lockFields} />}
                          label="State"
                          disabled={lockFields}
                        />
                        <FormControlLabel
                          value="2"
                          control={<Radio disabled={lockFields} />}
                          label="City"
                          disabled={lockFields}
                        />
                      </RadioGroup>
                    </Stack>
                  </Grid>
                  {formData.n_for_type != 4 && formData.n_for_type != "4" && (
                    <Grid item xs={12}>
                      <Stack spacing={3}>
                        <label>
                          Select{" "}
                          {formData.n_for_type == 1 || formData.n_for_type === "1"
                            ? "State"
                            : "City"}
                        </label>
                        <Select
                          isMulti
                          filterOption={null}
                          value={selectedForTypeOpts}
                          onChange={(selected) => {
                            setSelectedForTypeOpts(selected || []);
                            const val = selected ? selected.map((s) => s.value).join(",") : "";
                            setFormData({ ...formData, n_for_id: val });
                          }}
                          onInputChange={handleForTypeInputChange}
                          onMenuScrollToBottom={handleForTypeMenuScroll}
                          menuPortalTarget={document.body}
                          options={forTypeOptions}
                          isDisabled={lockFields}
                          placeholder="Type to search..."
                          isLoading={isLoadingForTypeOptions}
                          noOptionsMessage={() =>
                            isLoadingForTypeOptions ? "Loading..." : "No options"
                          }
                        />
                      </Stack>
                    </Grid>
                  )}
                  {
                    // display Title and description if selected type is not Question and Answer
                    formData?.n_type != 3 && (
                      <>
                        <Grid item xs={12}>
                          <Stack spacing={3}>
                            <TextField
                              required
                              type="text"
                              label="Title"
                              fullWidth
                              value={formData?.n_title}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  n_title: e.target.value
                                });
                              }}
                            />
                          </Stack>
                        </Grid>

                        <Grid item xs={12}>
                          <FormLabel> Description</FormLabel>
                          <CKEditor
                            key={`desc_${formData?.n_type}`}
                            initData={formData?.n_description}
                            config={{
                              allowedContent: true,
                              extraPlugins: "colorbutton,font", // adds font + color options
                              removeButtons: "", // keep all defaults
                              colorButton_colors:
                                // 🔹 Default CKEditor palette (taken from docs)
                                "000000,993300,333300,003300,003366,000080,333399,333333," +
                                "800000,FF6600,808000,008000,008080,0000FF,666699,808080," +
                                "FF0000,FF9900,99CC00,339966,33CCCC,3366FF,800080,969696," +
                                "FF00FF,FFCC00,FFFF00,00FF00,00FFFF,00CCFF,993366,C0C0C0," +
                                "FF99CC,FFCC99,FFFF99,CCFFCC,CCFFFF,99CCFF,CC99FF,FFFFFF," +
                                // 🔹 Your extra theme colors (example: brand palette)
                                "123456,FFA500,4CAF50,9C27B0,2196F3,034766"
                            }}
                            onChange={(event) => {
                              const data = event.editor.getData();
                              setFormData((prevData) => ({
                                ...prevData,
                                n_description: data
                              }));
                            }}
                          />
                        </Grid>

                        <Grid item xs={6}>
                          <Stack spacing={3}>
                            <TextField
                              type="text"
                              label="URL"
                              fullWidth
                              value={formData?.n_link}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  n_link: e.target.value
                                });
                              }}
                            />
                          </Stack>
                        </Grid>
                        <Grid item xs={6}>
                          <Stack spacing={3}>
                            <TextField
                              type="text"
                              label="Button Title"
                              fullWidth
                              value={formData?.n_button_title}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  n_button_title: e.target.value
                                });
                              }}
                            />
                          </Stack>
                        </Grid>
                      </>
                    )
                  }
                  {(formData?.n_type == 0 || formData?.n_type == 1) && (
                    <Grid item xs={12}>
                      <Button
                        component="label"
                        variant="contained"
                        color="primary"
                        tabIndex={-1}
                        // disabled={lockFields}
                        sx={{ textTransform: "none", p: "10px" }}
                        startIcon={<UploadFile />}
                      >
                        Click to Upload file
                        <VisuallyHiddenInput
                          type="file"
                          required
                          multiple={false}
                          accept={getAcceptType(formData?.n_type)}
                          onChange={(event) => {
                            const uploadedFile = event.currentTarget.files[0];

                            // Check if file exists and validate its size
                            let maxSize = 2 * 1024 * 1024;

                            // Apply 10MB if audio
                            if (formData.n_type == 1) {
                              maxSize = 10 * 1024 * 1024;
                            }

                            const allowedImageTypes = [
                              "image/jpeg",
                              "image/png",
                              "image/jpg",
                              "image/gif"
                            ];
                            const allowedAudioTypes = ["audio/mpeg", "audio/wav", "audio/ogg"];

                            if (uploadedFile) {
                              const fileType = uploadedFile.type;

                              if (formData.n_type == 0 && !allowedImageTypes.includes(fileType)) {
                                let notify = notification({
                                  type: "error",
                                  message: "Please upload a valid image file.",
                                  position: "top"
                                });
                                notify();
                                return;
                              } else if (
                                formData.n_type == 1 &&
                                !allowedAudioTypes.includes(fileType)
                              ) {
                                let notify = notification({
                                  type: "error",
                                  message: "Please upload a valid audio file.",
                                  position: "top"
                                });
                                notify();
                                return;
                              }

                              if (uploadedFile.size > maxSize) {
                                let notify = notification({
                                  type: "error",
                                  message: `File size exceeds ${
                                    maxSize / (1024 * 1024)
                                  }MB. Please upload a smaller file.`,
                                  position: "top"
                                });
                                notify();
                                return;
                              }
                            }

                            // If valid, update the state
                            setFile({ file: uploadedFile });
                            setfileimage(URL.createObjectURL(uploadedFile));
                          }}
                        />
                      </Button>

                      {/* Display uploaded Image / Audio */}
                      {page == 1 &&
                        (fileimage !== undefined ? (
                          <div style={{ marginTop: "10px" }}>
                            {formData?.n_type == 0 ? (
                              <>
                                <h4>Image Preview</h4>
                                <div className="position-relative">
                                  <img
                                    src={fileimage}
                                    alt="Uploaded file preview"
                                    style={{
                                      width: "450px",
                                      objectFit: "contain",
                                      height: "250px",
                                      boxShadow: "0 0 5px #ccc",
                                      borderRadius: "5px"
                                    }}
                                  />
                                </div>
                              </>
                            ) : formData?.n_type == 1 ? (
                              <>
                                <h4>Audio Preview</h4>
                                <audio controls src={fileimage} />
                              </>
                            ) : null}
                          </div>
                        ) : (
                          ""
                        ))}
                      {page == 2 &&
                        (fileimage !== undefined ? (
                          <div style={{ marginTop: "10px" }}>
                            {formData?.n_type == 0 ? (
                              <>
                                <h4>Image Preview</h4>
                                <div className="position-relative">
                                  <img
                                    src={fileimage}
                                    alt="Uploaded file preview"
                                    style={{
                                      width: "450px",
                                      objectFit: "contain",
                                      height: "250px",
                                      boxShadow: "0 0 5px #ccc",
                                      borderRadius: "5px"
                                    }}
                                  />
                                </div>
                              </>
                            ) : formData?.n_type == 1 ? (
                              <>
                                <h4>Audio Preview</h4>
                                <audio controls src={fileimage} />
                              </>
                            ) : null}
                          </div>
                        ) : (
                          <div style={{ marginTop: "10px" }}>
                            {formData?.n_type == 0 && formData?.n_image ? (
                              <>
                                <h4>Image Preview</h4>
                                <div className="position-relative">
                                  <img
                                    src={`${Routes.API_HOSTNAME}images/notification/${formData?.n_image}`}
                                    alt="Uploaded file preview"
                                    style={{
                                      width: "450px",
                                      objectFit: "contain",
                                      height: "250px",
                                      boxShadow: "0 0 5px #ccc",
                                      borderRadius: "5px"
                                    }}
                                  />
                                </div>
                              </>
                            ) : formData?.n_type == 1 && formData?.n_image ? (
                              <>
                                <h4>Audio Preview</h4>
                                <audio
                                  controls
                                  src={`${Routes.API_HOSTNAME}images/notification/${formData?.n_image}`}
                                />
                              </>
                            ) : null}
                          </div>
                        ))}
                    </Grid>
                  )}
                  {formData?.n_type == 2 && (
                    <>
                      <Grid item xs={12}>
                        <Stack spacing={3}>
                          <TextField
                            required
                            type="text"
                            label="Video URL"
                            fullWidth
                            disabled={lockFields}
                            value={formData?.n_video}
                            onChange={(e) => {
                              setFormData({ ...formData, n_video: e.target.value });
                            }}
                          />
                        </Stack>
                      </Grid>
                      {/* Display Youtube URL */}
                      {formData?.n_video != "" && getYoutubeVideoId(formData?.n_video) != null && (
                        <Grid item xs={12}>
                          <div
                            className="rounded"
                            style={{
                              position: "relative",
                              height: "250px",
                              overflow: "hidden",
                              maxWidth: "100%"
                            }}
                          >
                            <p>hello</p>
                            <iframe
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "450px",
                                height: "250px"
                              }}
                              src={getYoutubeVideoId(formData?.n_video)}
                              title="YouTube video player"
                              frameBorder="0"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowFullScreen
                            />
                          </div>
                        </Grid>
                      )}
                    </>
                  )}
                  {/* Display Question and Answer */}
                  {formData?.n_type == 3 && (
                    <>
                      <Grid item xs={12}>
                        <Stack spacing={3}>
                          <TextField
                            required
                            type="text"
                            label="Question"
                            fullWidth
                            value={formData?.n_question}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                n_question: e.target.value
                              });
                            }}
                          />
                        </Stack>
                      </Grid>

                      <Grid item xs={12}>
                        <FormLabel> Answer</FormLabel>
                        <CKEditor
                          key={`answer_${formData?.n_type}`}
                          initData={formData?.n_answer}
                          config={{
                            allowedContent: true,
                            extraPlugins: "colorbutton,font", // adds font + color options
                            removeButtons: "", // keep all defaults
                            colorButton_colors:
                              // 🔹 Default CKEditor palette (taken from docs)
                              "000000,993300,333300,003300,003366,000080,333399,333333," +
                              "800000,FF6600,808000,008000,008080,0000FF,666699,808080," +
                              "FF0000,FF9900,99CC00,339966,33CCCC,3366FF,800080,969696," +
                              "FF00FF,FFCC00,FFFF00,00FF00,00FFFF,00CCFF,993366,C0C0C0," +
                              "FF99CC,FFCC99,FFFF99,CCFFCC,CCFFFF,99CCFF,CC99FF,FFFFFF," +
                              // 🔹 Your extra theme colors (example: brand palette)
                              "123456,FFA500,4CAF50,9C27B0,2196F3,034766"
                          }}
                          onChange={(event) => {
                            const data = event.editor.getData();
                            setFormData((prevData) => ({
                              ...prevData,
                              n_answer: data
                            }));
                          }}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <Stack spacing={3}>
                          <TextField
                            type="text"
                            label="URL"
                            fullWidth
                            value={formData?.n_link}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                n_link: e.target.value
                              });
                            }}
                          />
                        </Stack>
                      </Grid>
                      <Grid item xs={6}>
                        <Stack spacing={3}>
                          <TextField
                            type="text"
                            label="Button Title"
                            fullWidth
                            value={formData?.n_button_title}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                n_button_title: e.target.value
                              });
                            }}
                          />
                        </Stack>
                      </Grid>
                    </>
                  )}

                  {/* Schedule Entries */}
                  <Grid item xs={12}>
                    <ScheduleEntryList
                      entries={scheduleEntries}
                      setEntries={setScheduleEntries}
                      isEditMode={page === 2}
                      lockAll={sentLocked}
                    />
                  </Grid>

                  {/* submit and rest form state */}
                  <Grid item xs={12}>
                    <Button
                      type="button"
                      variant="contained"
                      color="primary"
                      sx={{ marginRight: "5px" }}
                      disabled={isSubmitting}
                      onClick={() => {
                        if (validationHandler()) setOpenPreview(true);
                      }}
                    >
                      {isSubmitting ? "Submitting..." : "Submit"}
                    </Button>
                    <Button
                      variant="outlined"
                      color="error"
                      onClick={() => {
                        resetFormData();
                        setPage(0);
                        setfileimage();
                      }}
                    >
                      Cancel
                    </Button>
                  </Grid>
                </Grid>
              </Card>
            </>
          ) : (
            <>
              <NotificationFilters
                filtereddata={filtereddata}
                setFilteredData={setFilteredData}
                loginUser={loginUser}
              />
              <Card className="p-2" style={{ padding: "15px" }}>
                <Button className="btn btn-export">
                  <CSVLink
                    data={formattedCSVData}
                    headers={expo_columns}
                    filename={"Notification.csv"}
                    className="btn btn-primary test"
                    target="_blank"
                  >
                    Export CSV
                  </CSVLink>
                </Button>
                <NotificationTable
                  data={newNotificationList}
                  isLoading={isLoading}
                  loginUser={loginUser}
                  onDelete={handleDeleteClick}
                  onEdit={handleEdit}
                  onViewRead={openModalWithNotification}
                  pagination={pagination}
                  onPageChange={handlePageChange}
                  onPerRowsChange={handlePerRowsChange}
                />
              </Card>
            </>
          )}

          <Modal
            open={readNotificationDataModal}
            onClose={closeModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={readNotificationModalStyle}>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                style={{ marginBottom: "5px", textAlign: "center" }}
              >
                Notification Read By Members
              </Typography>
              <hr />

              <Stack style={{ marginBottom: "10px", marginTop: "10px" }}>
                <Grid container spacing={2} style={{ marginBottom: "10px" }}>
                  <Grid item xs={6}></Grid>
                  <Grid item xs={4}></Grid>
                  <Grid item xs={2}>
                    <Button className="btn btn-export">
                      <CSVLink
                        data={readNotificationList}
                        headers={export_readNotificationDetailColumns}
                        filename={`Notification Read Date.csv`}
                        className="btn btn-primary test"
                        target="_blank"
                      >
                        Export CSV
                      </CSVLink>
                    </Button>
                  </Grid>
                </Grid>
                <Card>
                  <DataTable
                    filter
                    fixedHeaderScrollHeight="450px"
                    fixedHeader={true}
                    pagination
                    highlightOnHover
                    columns={readNotificationDetailColumns}
                    data={readNotificationList}
                    progressPending={isLoading2}
                    progressComponent={<CustomLoader />}
                  />
                </Card>
              </Stack>
              <hr />
              <div
                style={{
                  margin: "10px  auto 0",
                  display: "flex",
                  justifyContent: "center"
                }}
              >
                <Button
                  variant="outlined"
                  onClick={closeModal}
                  style={{ marginTop: "0px", marginRight: "0px" }}
                >
                  Close
                </Button>
              </div>
            </Box>
          </Modal>

          {/* Preview Confirmation Dialog */}
          <Dialog open={openPreview} onClose={() => setOpenPreview(false)} maxWidth="md" fullWidth>
            <DialogTitle sx={{ fontWeight: 700 }}>Preview Notification</DialogTitle>
            <DialogContent>
              <Typography variant="subtitle2" gutterBottom>
                Title: {formData.n_title}
              </Typography>
              <Typography variant="subtitle2" gutterBottom>
                Type:{" "}
                {formData.n_type == 0
                  ? "Photo"
                  : formData.n_type == 1
                    ? "Audio"
                    : formData.n_type == 2
                      ? "Video"
                      : "Q&A"}
              </Typography>
              <Typography variant="subtitle2" gutterBottom>
                Target: {formData.n_for_type} — {formData.n_for_id || "All"}
              </Typography>
              <Divider sx={{ my: 1 }} />
              <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                Schedule Entries ({scheduleEntries.length})
              </Typography>
              {scheduleEntries.map((entry, idx) => (
                <Box
                  key={idx}
                  sx={{ p: 1, mb: 1, border: "1px solid #e0e0e0", borderRadius: 1 }}
                >
                  <Typography variant="body2">
                    Entry {idx + 1}: {entry.s_date} — {entry.e_date} |{" "}
                    {entry.notification_send_type === "1"
                      ? "Immediate"
                      : `Scheduled: ${entry.n_date_time}`}{" "}
                    | Show on Home: {entry.show_on_home ? "Yes" : "No"}
                  </Typography>
                </Box>
              ))}
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenPreview(false)} variant="outlined">
                Cancel
              </Button>
              <Button
                onClick={() => {
                  setOpenPreview(false);
                  handleFormSubmit();
                }}
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Confirm & Submit"}
              </Button>
            </DialogActions>
          </Dialog>
        </Container>
      </Page>
    </>
  );
}

export default Notification;
